import script from "./PopUps.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopUps.vue?vue&type=script&lang=ts&setup=true"

import "./PopUps.vue?vue&type=style&index=0&id=d7d341c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7d341c6"]])

export default __exports__